import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILED,
  EDIT_COUNTRY,
  EDIT_CITY
} from "../store/types";

const INITIAL_STATE = {
  countries: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const countriesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES:
      return {
        ...state,
        loading: true
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload,
        loading: false
      };
    case FETCH_COUNTRIES_FAILED:
      return {
        ...state,
        countries: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_COUNTRY:
      return state;
    case EDIT_CITY:
      return state;
    default:
      return state;
  }
};
